

























































import { generateRequirementsList } from '@/components/order-requirements'
import { generateSpecifications } from '@/components/order-specifications'
import Card from '@/components/Card.vue'
import VehicleSpecificationsForm from '../VehicleSpecificationsForm.vue'
import VehicleTypes from '@/components/order-common/VehicleTypes.vue'
import { LoadSpecifications } from '@/services/models/marketplace-service-model'

export default {
  components: {
    Card,
    VehicleSpecificationsForm,
    VehicleTypes
  },
  props: {
    transport: { type: Object, required: true },
    transportRequest: { type: Object, required: true }
  },
  computed: {
    specifications() {
      const specifications: LoadSpecifications = generateSpecifications(this.transport)
      if (!specifications) return '-'

      return [
        specifications.weight,
        specifications.dimensions,
        specifications.palletInformation
      ]
        .filter(Boolean)
        .join(' | ')
    },
    requirements() {
      const list = generateRequirementsList(this.transport)
      if (!list.length) return '-'
      return list.map(key => this.$t(key)).join(' | ')
    }
  }
}
